import { styled } from "@mui/system";

export default styled("h1")`
  margin-top: 0;
`;
